import type { OrderBy } from '@/lib/graphql-query-builder';
import {
  buildListQuery,
  DEFAULT_ATTENDANCE_CORRECTIONS_ORDER,
  DEFAULT_ATTENDANCES_ORDER,
} from '@/modules/attendance/hr-my-attendance/graphql/queries';

export { DEFAULT_ATTENDANCE_CORRECTIONS_ORDER, DEFAULT_ATTENDANCES_ORDER };

/** The roster's employees (UserProfileDetail), A to Z by name by default. */
export const DEFAULT_ROSTER_ORDER: OrderBy[] = [{ field: 'DisplayName', direction: 'ASC' }];

const ATTENDANCE_FIELDS = `
        ItemId
        AttendanceDate
        StartTimeUtc
        EndTimeUtc
        Timezone
        UserId
        DisplayName
        DepartmentId
        DepartmentName
        DepartmentKey
        TotalWorkTimeInSecond
        TotalBreakTimeInSecond
        TotalClockTimeInSecond
        ExpectedWorkingHourInSecond
        OverTimeInSecond
        IsOpen
        IsForceClockOut
        Status
        BreakTimeDetails {
          StartTimeUtc
          EndTimeUtc
          Type
        }
`;

/** Newest day first by default. */
export const buildGetAttendancesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_ATTENDANCES_ORDER
) =>
  buildListQuery(
    'Attendances',
    'getAttendances',
    ATTENDANCE_FIELDS,
    where,
    pageNo,
    pageSize,
    order
  );

const ATTENDANCE_CORRECTION_FIELDS = `
        ItemId
        CreatedDate
        AttendanceId
        UserId
        DepartmentId
        DepartmentName
        DepartmentKey
        CorrectionDate
        StartTimeUtc
        EndTimeUtc
        Timezone
        BreakTimeDetails {
          StartTimeUtc
          EndTimeUtc
          Type
        }
        Comment
        Status
        Note
        Fine
        LastUpdatedDate
        ActionTakenBy
`;

/** By default latest corrected day first, like the legacy `GetAllUserAttendanceCorrection` sort
 * `{ CorrectionDateUTC: -1 }` (AttendanceCorrectionService.cs:94); ties go to the latest change, as in
 * KosovoAttendanceCorrectionService.cs:363. */
export const buildGetAttendanceCorrectionsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_ATTENDANCE_CORRECTIONS_ORDER
) =>
  buildListQuery(
    'AttendanceCorrections',
    'getAttendanceCorrections',
    ATTENDANCE_CORRECTION_FIELDS,
    where,
    pageNo,
    pageSize,
    order
  );
